import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Fingerprint, MailCheck, MonitorSmartphone, Timer } from "lucide-react";
import { ShellLayout } from "@/components/shell/ShellLayout";
import { StatCard } from "@/components/shell/StatCard";
import { FixtureBadge } from "@/components/shell/Badges";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { formatDateTime, timeUntil } from "@/lib/format";

export default function AccountHome() {
  const { user } = useAuth();
  const [overview, setOverview] = useState(null);
  useEffect(() => {
    api.get("/account/overview").then(({ data }) => setOverview(data)).catch(() => setOverview(null));
  }, []);
  const security = overview?.security;

  return (
    <ShellLayout area="account" eyebrow="Customer account" title={`Hello, ${user.display_name}`}>
      <div data-testid="account-dashboard" className="space-y-8">
        <div className="flex flex-wrap items-center gap-3">
          <p className="text-sm text-slate-400">Your canonical BIZII identity. Product features arrive in later phases.</p>
          <FixtureBadge user={user} />
        </div>
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          <StatCard index={0} label="Authenticator" icon={Fingerprint} value={security ? (security.mfa_enabled ? "Enabled" : "Off") : "…"} tone={security?.mfa_enabled ? "good" : "warn"} sub="Optional for customers" testId="account-stat-mfa" />
          <StatCard index={1} label="Email" icon={MailCheck} value={security ? (security.email_verified ? "Verified" : "Unverified") : "…"} tone={security?.email_verified ? "good" : "warn"} sub={user.email} testId="account-stat-email" />
          <StatCard index={2} label="Active sessions" icon={MonitorSmartphone} value={security ? security.active_sessions : "…"} sub="Across all devices" testId="account-stat-sessions" />
          <StatCard index={3} label="Session expires" icon={Timer} value={security ? timeUntil(security.session_expires_at) : "…"} tone="accent" sub="7-day absolute lifetime" testId="account-stat-expiry" />
        </div>
        <div className="bz-card">
          <p className="bz-caption">Security posture</p>
          <p className="mt-3 text-sm text-slate-300">
            Password last changed <span className="text-white">{formatDateTime(security?.password_changed_at)}</span>.
          </p>
          <Link to="/account/security" data-testid="account-go-security-link" className="bz-btn-secondary mt-5 text-xs">
            Manage security settings
          </Link>
        </div>
      </div>
    </ShellLayout>
  );
}
